import React from 'react';
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import Icon from "./icon";

function InputLabel ({label, value, onChange, inputType ,children, require = false, className, placeholder, rows=3, info}){

    const render =()=>{
        switch (inputType) {
            case "TEXT": return <InputText value={value} onChange={onChange} placeholder={placeholder}/>
            case "TEXTAREA": return <InputTextarea value={value} onChange={onChange} placeholder={placeholder} rows={rows} />
            default : return children;
        }
    }
    return(
        <div className={className}>
            <div className={`text-xs flex flex-column w-full gap-1`}>
                {label&&<span className="pr-2">{require&&<i className="text-red-500">*</i>}{label}:</span>}
                {render()}
                {info&&(
                    <div className="flex align-items-center gap-1 text-xs text-400">
                        <Icon icon="mi mi:info" className="text-400 text-lg"/>
                        <span>{info}</span>
                    </div>
                )}

            </div>
        </div>
    )
}

export default InputLabel;